import axios from '@/axios';
import _ from 'lodash';

let accessToken = localStorage.accessToken;
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

export default {

  namespaced: true,

  actions: {

    async getAvailableZones({commit}, organization_id) {
      let org_id = parseInt(organization_id);
      if (isNaN(org_id)) throw new Error("invalid organization id");
      try {
        let res = await axios.get(`/organization/${org_id}/zone`);
        commit('SET_ZONES', res.data.data);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },

    async getOrganizationShippingRates({commit}, organization_id) {
      let org_id = parseInt(organization_id);
      if (isNaN(org_id)) throw new Error("invalid organization id");

      try {
        let res = await axios.get(`organization/${org_id}/shipping-rate`);
        commit('SET_RATES', res.data.data);
      } catch(e) {
        console.log(e);
        throw e;
      }
    },

    async createOrganizationShippingRate({commit}, { rate, organization_id }) {
      let org_id = parseInt(organization_id);
      if (isNaN(org_id)) throw new Error("invalid organization id");

      try {
        let res = await axios.post(`organization/${org_id}/shipping-rate`, rate);
        commit('APPEND_RATE', res.data.data)
      } catch (e) {
        console.log(e);
        throw e;
      }
      
    },

    async updateOrganizationShippingRate({commit}, { rate, organization_id }) { 
      let org_id = parseInt(organization_id);
      if (isNaN(org_id)) throw new Error("invalid organization id");

      try {
        let res = await axios.patch(`organization/${org_id}/shipping-rate`, rate);
        commit('UPDATE_RATE', rate);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },

    async deleteOrganizationShippingRate({commit}, { rate, organization_id }) {
      let org_id = parseInt(organization_id);
      if (isNaN(org_id)) throw new Error("invalid organization id");

      try {
        let res = await axios.delete(`organization/${org_id}/shipping-rate/${rate.id}`);
        commit('REMOVE_RATE', rate);
      } catch (e) {
        console.log(e);
        throw e;
      }

    },
  },


  mutations: {

    SET_ZONES(state, zones) {
      state.zones = zones;
    },

    SET_RATES(state, rates) {
      state.shipping_rates = rates;
    },

    UPDATE_RATE(state, rate) {
      let idx = state.shipping_rates.findIndex(x => x.id == rate.id);
      if (idx < 0) return;

      state.shipping_rates[idx] = rate;
    },

    APPEND_RATE(state, rate) {
      state.shipping_rates.push(rate);
    },

    REMOVE_RATE(state, rate) {
      state.shipping_rates = state.shipping_rates.filter(x => x.id != rate.id);
    },
  },

  state: {

    zones: [],

    types: [{
        type_id: 1,
        name: "Flat Per Order", 
      }, {
        type_id: 2,
        name: "Per Product",
      }, {
        type_id: 3,
        name: "Weight Based", 
      }, {
        type_id: 4,
        name: "Fullfillment Provider Rate"
      },
    ],

    shipping_rates: []
  }
}
